<template>
    <div class="center-address-add">
        <center-add-title>{{$t("message.caddress.addTitle")}}</center-add-title>
        <slot name="addForm">
        </slot>
    </div>
</template>

<script>
export default {
    components: {
        centerAddTitle: () => import("@/components/center/centerAddTitle")
    }
}
</script>

<style scoped>
.center-address-add{
    margin-top: 30px;
    padding-bottom: 20px;
    background: #fff;
}
</style>
